import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: 'input[numbersOnly]'
})

export class NumberDirective {

  private specialKeys: Array<string> = ['Tab',
  'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Backspace', 'Delete', 'Enter'];

  constructor() {
    // Unused
   }

  @HostListener('keydown', ['$event']) onKeyDown(event): any {
    var charCode = (event.which) ? event.which : event.keyCode;

    if ((charCode == 65 || charCode == 86 || charCode == 67 || charCode == 88 || charCode == 90) && (event.ctrlKey === true || event.metaKey === true)) {
      return;
    }

    // Only Numbers 0-9
    if ((charCode < 48 || charCode > 57) && (charCode < 96 || charCode > 105) && this.specialKeys.indexOf(event.key) == -1) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    let dataToPaste = event.clipboardData.getData('text');
    if (isNaN(Number(dataToPaste))) {
      event.preventDefault();
    }

    // Validate 'dataToPaste' against the regex
  }

}
